module.exports = __webpack_public_path__ + "static/media/affordance.ae5f2b8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXLanding/images/affordance.svg
// module id = 1272
// module chunks = 0